import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import classes from "./InfoModal.module.css";

export default function InfoModal(props) {
  const { handleClose, icon, header, message } = props;
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box className={classes.modalContainer}>
        <div className={classes.container}>
          <div className={classes.header}>
            <CloseIcon
              className={classes.close}
              onClick={() => {
                handleClose();
              }}
            />
          </div>
          <div className={classes.infoContainer}>
            <p className={classes.infoHeader}>
              {icon} {header}{" "}
            </p>

            <div className={classes.info}>{message}</div>
          </div>
        </div>
      </Box>
    </Modal>
  );
}
